<!--begin::Modal - View Users-->
<div class="modal fade" id="kt_modal_view_users" tabindex="-1" aria-hidden="true">
	<!--begin::Modal dialog-->
	<div class="modal-dialog mw-650px">
		<!--begin::Modal content-->
		<div class="modal-content">
			<!--begin::Modal header-->
			<div class="modal-header pb-0 border-0 justify-content-end">
				<!--begin::Close-->
				<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
					<i class="ki-duotone ki-cross fs-1">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
				</div>
				<!--end::Close-->
			</div>
			<!--begin::Modal header-->
			<!--begin::Modal body-->
			<div class="modal-body scroll-y mx-5 mx-xl-18 pt-0 pb-15">
				<!--begin::Heading-->
				<div class="text-center mb-13">
					<!--begin::Title-->
					<h1 class="mb-3">Browse Users</h1>
					<!--end::Title-->
					<!--begin::Description-->
					<div class="text-muted fw-semibold fs-5">If you need more info, please check out our
						<a href="#" class="link-primary fw-bold">Users Directory</a>.
					</div>
					<!--end::Description-->
				</div>
				<!--end::Heading-->
				<!--begin::Users-->
				<div class="mb-15">
					<!--begin::List-->
					<div class="mh-375px scroll-y me-n7 pe-7">
						<!--begin::User-->
						<div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
							<!--begin::Details-->
							<div class="d-flex align-items-center">
								<!--begin::Avatar-->
								<div class="symbol symbol-35px symbol-circle">
									<img alt="Pic" src="assets/media/avatars/300-6.jpg" />
								</div>
								<!--end::Avatar-->
								<!--begin::Details-->
								<div class="ms-6">
									<!--begin::Name-->
									<a href="#" class="d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary">Emma Smith
										<span class="badge badge-light fs-8 fw-semibold ms-2">Art Director</span></a>
									<!--end::Name-->
									<!--begin::Email-->
									<div class="fw-semibold text-muted">smith@kpmg.com</div>
									<!--end::Email-->
								</div>
								<!--end::Details-->
							</div>
							<!--end::Details-->
							<!--begin::Stats-->
							<div class="d-flex">
								<!--begin::Sales-->
								<div class="text-end">
									<div class="fs-5 fw-bold text-gray-900">$23,000</div>
									<div class="fs-7 text-muted">Sales</div>
								</div>
								<!--end::Sales-->
							</div>
							<!--end::Stats-->
						</div>
						<!--end::User-->
						<!--begin::User-->
						<div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
							<!--begin::Details-->
							<div class="d-flex align-items-center">
								<!--begin::Avatar-->
								<div class="symbol symbol-35px symbol-circle">
									<span class="symbol-label bg-light-danger text-danger fw-semibold">M</span>
								</div>
								<!--end::Avatar-->
								<!--begin::Details-->
								<div class="ms-6">
									<!--begin::Name-->
									<a href="#" class="d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary">Melody Macy
										<span class="badge badge-light fs-8 fw-semibold ms-2">Marketing Analytic</span></a>
									<!--end::Name-->
									<!--begin::Email-->
									<div class="fw-semibold text-muted">melody@altbox.com</div>
									<!--end::Email-->
								</div>
								<!--end::Details-->
							</div>
							<!--end::Details-->
							<!--begin::Stats-->
							<div class="d-flex">
								<!--begin::Sales-->
								<div class="text-end">
									<div class="fs-5 fw-bold text-gray-900">$50,500</div>
									<div class="fs-7 text-muted">Sales</div>
								</div>
								<!--end::Sales-->
							</div>
							<!--end::Stats-->
						</div>
						<!--end::User-->
						<!--begin::User-->
						<div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
							<!--begin::Details-->
							<div class="d-flex align-items-center">
								<!--begin::Avatar-->
								<div class="symbol symbol-35px symbol-circle">
									<img alt="Pic" src="assets/media/avatars/300-1.jpg" />
								</div>
								<!--end::Avatar-->
								<!--begin::Details-->
								<div class="ms-6">
									<!--begin::Name-->
									<a href="#" class="d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary">Max Smith
										<span class="badge badge-light fs-8 fw-semibold ms-2">Software Enginer</span></a>
									<!--end::Name-->
									<!--begin::Email-->
									<div class="fw-semibold text-muted">max@kt.com</div>
									<!--end::Email-->
								</div>
								<!--end::Details-->
							</div>
							<!--end::Details-->
							<!--begin::Stats-->
							<div class="d-flex">
								<!--begin::Sales-->
								<div class="text-end">
									<div class="fs-5 fw-bold text-gray-900">$75,900</div>
									<div class="fs-7 text-muted">Sales</div>
								</div>
								<!--end::Sales-->
							</div>
							<!--end::Stats-->
						</div>
						<!--end::User-->
						<!--begin::User-->
						<div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
							<!--begin::Details-->
							<div class="d-flex align-items-center">
								<!--begin::Avatar-->
								<div class="symbol symbol-35px symbol-circle">
									<img alt="Pic" src="assets/media/avatars/300-5.jpg" />
								</div>
								<!--end::Avatar-->
								<!--begin::Details-->
								<div class="ms-6">
									<!--begin::Name-->
									<a href="#" class="d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary">Sean Bean
										<span class="badge badge-light fs-8 fw-semibold ms-2">Web Developer</span></a>
									<!--end::Name-->
									<!--begin::Email-->
									<div class="fw-semibold text-muted">sean@dellito.com</div>
									<!--end::Email-->
								</div>
								<!--end::Details-->
							</div>
							<!--end::Details-->
							<!--begin::Stats-->
							<div class="d-flex">
								<!--begin::Sales-->
								<div class="text-end">
									<div class="fs-5 fw-bold text-gray-900">$10,500</div>
									<div class="fs-7 text-muted">Sales</div>
								</div>
								<!--end::Sales-->
							</div>
							<!--end::Stats-->
						</div>
						<!--end::User-->
						<!--begin::User-->
						<div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
							<!--begin::Details-->
							<div class="d-flex align-items-center">
								<!--begin::Avatar-->
								<div class="symbol symbol-35px symbol-circle">
									<img alt="Pic" src="assets/media/avatars/300-25.jpg" />
								</div>
								<!--end::Avatar-->
								<!--begin::Details-->
								<div class="ms-6">
									<!--begin::Name-->
									<a href="#" class="d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary">Brian Cox
										<span class="badge badge-light fs-8 fw-semibold ms-2">UI/UX Designer</span></a>
									<!--end::Name-->
									<!--begin::Email-->
									<div class="fw-semibold text-muted">brian@exchange.com</div>
									<!--end::Email-->
								</div>
								<!--end::Details-->
							</div>
							<!--end::Details-->
							<!--begin::Stats-->
							<div class="d-flex">
								<!--begin::Sales-->
								<div class="text-end">
									<div class="fs-5 fw-bold text-gray-900">$20,000</div>
									<div class="fs-7 text-muted">Sales</div>
								</div>
								<!--end::Sales-->
							</div>
							<!--end::Stats-->
						</div>
						<!--end::User-->
						<!--begin::User-->
						<div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
							<!--begin::Details-->
							<div class="d-flex align-items-center">
								<!--begin::Avatar-->
								<div class="symbol symbol-35px symbol-circle">
									<span class="symbol-label bg-light-warning text-warning fw-semibold">C</span>
								</div>
								<!--end::Avatar-->
								<!--begin::Details-->
								<div class="ms-6">
									<!--begin::Name-->
									<a href="#" class="d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary">Mikaela Collins
										<span class="badge badge-light fs-8 fw-semibold ms-2">Head Of Marketing</span></a>
									<!--end::Name-->
									<!--begin::Email-->
									<div class="fw-semibold text-muted">mik@pex.com</div>
									<!--end::Email-->
								</div>
								<!--end::Details-->
							</div>
							<!--end::Details-->
							<!--begin::Stats-->
							<div class="d-flex">
								<!--begin::Sales-->
								<div class="text-end">
									<div class="fs-5 fw-bold text-gray-900">$9,300</div>
									<div class="fs-7 text-muted">Sales</div>
								</div>
								<!--end::Sales-->
							</div>
							<!--end::Stats-->
						</div>
						<!--end::User-->
						<!--begin::User-->
						<div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
							<!--begin::Details-->
							<div class="d-flex align-items-center">
								<!--begin::Avatar-->
								<div class="symbol symbol-35px symbol-circle">
									<img alt="Pic" src="assets/media/avatars/300-9.jpg" />
								</div>
								<!--end::Avatar-->
								<!--begin::Details-->
								<div class="ms-6">
									<!--begin::Name-->
									<a href="#" class="d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary">Francis Mitcham
										<span class="badge badge-light fs-8 fw-semibold ms-2">Software Arcitect</span></a>
									<!--end::Name-->
									<!--begin::Email-->
									<div class="fw-semibold text-muted">f.mit@kpmg.com</div>
									<!--end::Email-->
								</div>
								<!--end::Details-->
							</div>
							<!--end::Details-->
							<!--begin::Stats-->
							<div class="d-flex">
								<!--begin::Sales-->
								<div class="text-end">
									<div class="fs-5 fw-bold text-gray-900">$15,000</div>
									<div class="fs-7 text-muted">Sales</div>
								</div>
								<!--end::Sales-->
							</div>
							<!--end::Stats-->
						</div>
						<!--end::User-->
						<!--begin::User-->
						<div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
							<!--begin::Details-->
							<div class="d-flex align-items-center">
								<!--begin::Avatar-->
								<div class="symbol symbol-35px symbol-circle">
									<span class="symbol-label bg-light-danger text-danger fw-semibold">O</span>
								</div>
								<!--end::Avatar-->
								<!--begin::Details-->
								<div class="ms-6">
									<!--begin::Name-->
									<a href="#" class="d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary">Olivia Wild
										<span class="badge badge-light fs-8 fw-semibold ms-2">System Admin</span></a>
									<!--end::Name-->
									<!--begin::Email-->
									<div class="fw-semibold text-muted">olivia@corpmail.com</div>
									<!--end::Email-->
								</div>
								<!--end::Details-->
							</div>
							<!--end::Details-->
							<!--begin::Stats-->
							<div class="d-flex">
								<!--begin::Sales-->
								<div class="text-end">
									<div class="fs-5 fw-bold text-gray-900">$23,000</div>
									<div class="fs-7 text-muted">Sales</div>
								</div>
								<!--end::Sales-->
							</div>
							<!--end::Stats-->
						</div>
						<!--end::User-->
						<!--begin::User-->
						<div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
							<!--begin::Details-->
							<div class="d-flex align-items-center">
								<!--begin::Avatar-->
								<div class="symbol symbol-35px symbol-circle">
									<span class="symbol-label bg-light-primary text-primary fw-semibold">N</span>
								</div>
								<!--end::Avatar-->
								<!--begin::Details-->
								<div class="ms-6">
									<!--begin::Name-->
									<a href="#" class="d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary">Neil Owen
										<span class="badge badge-light fs-8 fw-semibold ms-2">Account Manager</span></a>
									<!--end::Name-->
									<!--begin::Email-->
									<div class="fw-semibold text-muted">owen.neil@gmail.com</div>
									<!--end::Email-->
								</div>
								<!--end::Details-->
							</div>
							<!--end::Details-->
							<!--begin::Stats-->
							<div class="d-flex">
								<!--begin::Sales-->
								<div class="text-end">
									<div class="fs-5 fw-bold text-gray-900">$45,800</div>
									<div class="fs-7 text-muted">Sales</div>
								</div>
								<!--end::Sales-->
							</div>
							<!--end::Stats-->
						</div>
						<!--end::User-->
						<!--begin::User-->
						<div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
							<!--begin::Details-->
							<div class="d-flex align-items-center">
								<!--begin::Avatar-->
								<div class="symbol symbol-35px symbol-circle">
									<img alt="Pic" src="assets/media/avatars/300-23.jpg" />
								</div>
								<!--end::Avatar-->
								<!--begin::Details-->
								<div class="ms-6">
									<!--begin::Name-->
									<a href="#" class="d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary">Dan Wilson
										<span class="badge badge-light fs-8 fw-semibold ms-2">Web Desinger</span></a>
									<!--end::Name-->
									<!--begin::Email-->
									<div class="fw-semibold text-muted">dam@consilting.com</div>
									<!--end::Email-->
								</div>
								<!--end::Details-->
							</div>
							<!--end::Details-->
							<!--begin::Stats-->
							<div class="d-flex">
								<!--begin::Sales-->
								<div class="text-end">
									<div class="fs-5 fw-bold text-gray-900">$90,500</div>
									<div class="fs-7 text-muted">Sales</div>
								</div>
								<!--end::Sales-->
							</div>
							<!--end::Stats-->
						</div>
						<!--end::User-->
						<!--begin::User-->
						<div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
							<!--begin::Details-->
							<div class="d-flex align-items-center">
								<!--begin::Avatar-->
								<div class="symbol symbol-35px symbol-circle">
									<span class="symbol-label bg-light-danger text-danger fw-semibold">E</span>
								</div>
								<!--end::Avatar-->
								<!--begin::Details-->
								<div class="ms-6">
									<!--begin::Name-->
									<a href="#" class="d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary">Emma Bold
										<span class="badge badge-light fs-8 fw-semibold ms-2">Corporate Finance</span></a>
									<!--end::Name-->
									<!--begin::Email-->
									<div class="fw-semibold text-muted">emma@intenso.com</div>
									<!--end::Email-->
								</div>
								<!--end::Details-->
							</div>
							<!--end::Details-->
							<!--begin::Stats-->
							<div class="d-flex">
								<!--begin::Sales-->
								<div class="text-end">
									<div class="fs-5 fw-bold text-gray-900">$5,000</div>
									<div class="fs-7 text-muted">Sales</div>
								</div>
								<!--end::Sales-->
							</div>
							<!--end::Stats-->
						</div>
						<!--end::User-->
						<!--begin::User-->
						<div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
							<!--begin::Details-->
							<div class="d-flex align-items-center">
								<!--begin::Avatar-->
								<div class="symbol symbol-35px symbol-circle">
									<img alt="Pic" src="assets/media/avatars/300-12.jpg" />
								</div>
								<!--end::Avatar-->
								<!--begin::Details-->
								<div class="ms-6">
									<!--begin::Name-->
									<a href="#" class="d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary">Ana Crown
										<span class="badge badge-light fs-8 fw-semibold ms-2">Customer Relationship</span></a>
									<!--end::Name-->
									<!--begin::Email-->
									<div class="fw-semibold text-muted">ana.cf@limtel.com</div>
									<!--end::Email-->
								</div>
								<!--end::Details-->
							</div>
							<!--end::Details-->
							<!--begin::Stats-->
							<div class="d-flex">
								<!--begin::Sales-->
								<div class="text-end">
									<div class="fs-5 fw-bold text-gray-900">$70,000</div>
									<div class="fs-7 text-muted">Sales</div>
								</div>
								<!--end::Sales-->
							</div>
							<!--end::Stats-->
						</div>
						<!--end::User-->
						<!--begin::User-->
						<div class="d-flex flex-stack py-5">
							<!--begin::Details-->
							<div class="d-flex align-items-center">
								<!--begin::Avatar-->
								<div class="symbol symbol-35px symbol-circle">
									<span class="symbol-label bg-light-info text-info fw-semibold">A</span>
								</div>
								<!--end::Avatar-->
								<!--begin::Details-->
								<div class="ms-6">
									<!--begin::Name-->
									<a href="#" class="d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary">Robert Doe
										<span class="badge badge-light fs-8 fw-semibold ms-2">Marketing Executive</span></a>
									<!--end::Name-->
									<!--begin::Email-->
									<div class="fw-semibold text-muted">robert@benko.com</div>
									<!--end::Email-->
								</div>
								<!--end::Details-->
							</div>
							<!--end::Details-->
							<!--begin::Stats-->
							<div class="d-flex">
								<!--begin::Sales-->
								<div class="text-end">
									<div class="fs-5 fw-bold text-gray-900">$45,500</div>
									<div class="fs-7 text-muted">Sales</div>
								</div>
								<!--end::Sales-->
							</div>
							<!--end::Stats-->
						</div>
						<!--end::User-->
					</div>
					<!--end::List-->
				</div>
				<!--end::Users-->
				<!--begin::Notice-->
				<div class="d-flex justify-content-between">
					<!--begin::Label-->
					<div class="fw-semibold">
						<label class="fs-6">Adding Users by Team Members</label>
						<div class="fs-7 text-muted">If you need more info, please check budget planning</div>
					</div>
					<!--end::Label-->
					<!--begin::Switch-->
					<label class="form-check form-switch form-check-custom form-check-solid">
						<input class="form-check-input" type="checkbox" value="" checked="checked" />
						<span class="form-check-label fw-semibold text-muted">Allowed</span>
					</label>
					<!--end::Switch-->
				</div>
				<!--end::Notice-->
			</div>
			<!--end::Modal body-->
		</div>
		<!--end::Modal content-->
	</div>
	<!--end::Modal dialog-->
</div>
<!--end::Modal - View Users-->